import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-query-report',
  templateUrl: './query-report.component.html',
  styleUrls: ['./query-report.component.css']
})
export class QueryReportComponent implements OnInit {
	fullYear: number = new Date().getFullYear();
	yearArr= [];
	yearfArr= [];
	formType="";
	dataType="Form";
	respCom: any;
	comData: any;
	respRes: any;
	company=["All Insurer"];
	formReportType="LOB";
	formReportCol="";
	fileQuarter="Q1";
	filefYear="";
  fileYear="";
  selectMonth="";
	//company=[];
  constructor(private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
  	for (var i= this.fullYear-4;i<=this.fullYear;i++){
  		this.yearArr.push(i);
  	}
  	for (var i= this.fullYear-4;i<=this.fullYear;i++){
  		this.yearfArr.push(i+"-"+(i+1));
  		this.filefYear = i+"-"+(i+1);
  	}
  	const comReqData = {}
  	this._rest.companyList(comReqData).subscribe((res) => {
  		this.respCom	=	res;
  		this.comData	=	this.respCom.details;  		
  	})
  }

  changeCompany(selectElement){
  	var newList = [];
	for(var i=0;i<this.company.length;i++){
		console.log(this.company[i])
		if(this.company[i]!="All Insurer"){
			newList.push(this.company[i]);
		}
	}
  	if(newList.length==0){
  		newList	=	["All Insurer"];
  	}
  	this.company = newList;
  }
  generateReport(){
  	if(this.dataType=="Form" || this.dataType == "Data on Motor"){
  		this.generateFormReport();
    } else if(this.dataType=="Gross & Net Statistics" ){
      this.generateGrossNetReport();
    } else if(this.dataType=="Financial Highlights" ){
      this.generateFinHighReport();
    } else if(this.dataType=="Segment" ){
      this.generateSegmentReport();
    }else if(this.dataType=="Reinsurance" ){
      this.generateReInsReport();
  	} else {
  		alert("Sorry the report was not generated.");
  	}
  }
  generateReInsReport(){
    var errCounter  = 0;
    var errMsg = "";
    if(this.filefYear==""){
      errCounter++;
      errMsg = "Please select the Financial Year.";
    }
    if(this.fileQuarter==""){
      errCounter++;
      errMsg = "Please select the Quarter.";
    }
    if(this.formType==""){
      errCounter++;
      errMsg = "Please select the Form.";
    }
    if(this.formReportType==""){
      errCounter++;
      errMsg = "Please select the Report Type.";
    }
    if(this.formReportCol==""){
      errCounter++;
      errMsg = "Please select the Report Field.";
    }
    if(errCounter>0){
      alert(errMsg);
    } else {
      var saveData  = {
        "companyId":localStorage.getItem('companyId'),
        "userId":localStorage.getItem('userId'),
        "dataType":this.dataType,
        "year":this.filefYear,
        "quarter":this.fileQuarter,
        "formType":this.formType,
        "reportType":this.formReportType,
        "reportColumn":this.formReportCol
      };
      this._rest.saveCustomReport(saveData).subscribe((res) => {
        this.respRes  = res;
        console.log(this.respRes);
        if(this.respRes.error==0){
          this.router.navigate(['/analyst/qreportview/'+this.respRes.resp]);
        } else {
          alert(this.respRes.errorMessage);
        }
      });
    }
  }
  generateFormReport(){
    var errCounter  = 0;
    var errMsg = "";
    if(this.filefYear==""){
      errCounter++;
      errMsg = "Please select the Financial Year.";
    }
    if(this.fileQuarter==""){
      errCounter++;
      errMsg = "Please select the Quarter.";
    }
    if(this.formType==""){
      errCounter++;
      errMsg = "Please select the Form.";
    }
    if(this.formReportType==""){
      errCounter++;
      errMsg = "Please select the Report Type.";
    }
    if(errCounter>0){
      alert(errMsg);
    } else {
      var saveData  = {
        "companyId":localStorage.getItem('companyId'),
        "userId":localStorage.getItem('userId'),
        "dataType":this.dataType,
        "year":this.filefYear,
        "quarter":this.fileQuarter,
        "formType":this.formType,
        "reportType":this.formReportType,
        "reportColumn":this.formReportCol
      };
      this._rest.saveCustomReport(saveData).subscribe((res) => {
        this.respRes  = res;
        console.log(this.respRes);
        if(this.respRes.error==0){
          this.router.navigate(['/analyst/qreportview/'+this.respRes.resp]);
        } else {
          alert(this.respRes.errorMessage);
        }
      });
    }
  }
  generateGrossNetReport(){
    var errCounter  = 0;
    var errMsg = "";
    if(this.filefYear==""){
      errCounter++;
      errMsg = "Please select the Financial Year.";
    }
    if(this.formReportType==""){
      errCounter++;
      errMsg = "Please select the Report Type.";
    }
    if(this.formReportType=="LOB"){
      if(this.formReportCol==""){
        errCounter++;
        errMsg = "Please select the Report Column.";
      }
    }
    if(errCounter>0){
      alert(errMsg);
    } else {
      var saveData  = {
        "companyId":localStorage.getItem('companyId'),
        "userId":localStorage.getItem('userId'),
        "dataType":this.dataType,
        "year":this.filefYear,
        "quarter":"",
        "formType":"",
        "reportType":this.formReportType,
        "reportColumn":""
      }; 
      if(this.formReportType=="LOB"){
        saveData["reportColumn"]  = this.formReportCol
      }
      this._rest.saveCustomReport(saveData).subscribe((res) => {
        this.respRes  = res;
        console.log(this.respRes);
        if(this.respRes.error==0){
          this.router.navigate(['/analyst/qreportview/'+this.respRes.resp]);
        } else {
          alert(this.respRes.errorMessage);
        }
      });
    }
  }
  generateFinHighReport(){
    var errCounter  = 0;
    var errMsg = "";
    if(this.filefYear==""){
      errCounter++;
      errMsg = "Please select the Financial Year.";
    }
    if(this.fileQuarter==""){
      errCounter++;
      errMsg = "Please select the Quarter.";
    }
    
    if(errCounter>0){
      alert(errMsg);
    } else {
      var saveData  = {
        "companyId":localStorage.getItem('companyId'),
        "userId":localStorage.getItem('userId'),
        "dataType":this.dataType,
        "year":this.filefYear,
        "quarter":this.fileQuarter,
        "formType":"",
        "reportType":"",
        "reportColumn":""
      }; 
      this._rest.saveCustomReport(saveData).subscribe((res) => {
        this.respRes  = res;
        console.log(this.respRes);
        if(this.respRes.error==0){
          this.router.navigate(['/analyst/qreportview/'+this.respRes.resp]);
        } else {
          alert(this.respRes.errorMessage);
        }
      });
    }
  }
  generateSegmentReport(){
    var errCounter  = 0;
    var errMsg = "";
    if(this.fileYear==""){
      errCounter++;
      errMsg = "Please select the Year.";
    }
    if(this.selectMonth==""){
      errCounter++;
      errMsg = "Please select the Month.";
    }
    if(this.formReportType==""){
      errCounter++;
      errMsg = "Please select the Report Type.";
    }
    if(this.formReportType=="LOB"){
      if(this.formReportCol==""){
        errCounter++;
        errMsg = "Please select the Report Column.";
      }
    }
    if(errCounter>0){
      alert(errMsg);
    } else {
      var saveData  = {
        "companyId":localStorage.getItem('companyId'),
        "userId":localStorage.getItem('userId'),
        "dataType":this.dataType,
        "year":this.fileYear,
        "month":this.selectMonth,
        "formType":"",
        "reportType":this.formReportType,
        "reportColumn":""
      }; 
      if(this.formReportType=="LOB"){
        saveData["reportColumn"]  = this.formReportCol
      }
      this._rest.saveCustomReport(saveData).subscribe((res) => {
        this.respRes  = res;
        console.log(this.respRes);
        if(this.respRes.error==0){
          this.router.navigate(['/analyst/qreportview/'+this.respRes.resp]);
        } else {
          alert(this.respRes.errorMessage);
        }
      });
    }
  }

}
